import styled, { css } from 'styled-components';
import { landscape, mediaDesktop, mediaTablet } from 'utils/responsive';

export const Background = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-image: url(${({ src }) => src});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;

export const DescriptionWrapper = styled.div`
  height: 100%;
  width: 100%;
  padding: 20vh 0 0 0;
  overflow: auto;
  ${mediaTablet(css`
    padding: 25vh 0 0 0;
  `)}
  ${mediaDesktop(css`
    width: 40vw;
    padding: 40vh 0 0 0;
  `)}
`;

export const Content = styled.div`
  position: absolute;
  top: 12vh;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 86%;
  color: ${({ theme }) => theme.colors.primary.light};
  ${mediaTablet(`
    top: 15vh;
    ${landscape} {
      width: 60%;
    }
  `)}
  ${mediaDesktop(css`
    top: 0;
    bottom: 0;
    left: 62%;
    width: auto;
    justify-content: flex-end;
  `)}
`;

export const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
`;
